import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'


export interface NbPersonatabItem {
    id: number
    title: string
    version: string
    professional: boolean
    ordering: number
  }
  export interface NbPersonatab {
    id: number
    title: string
    active?: boolean
    version: string
    professional?: boolean
    ordering: number
    tab_text_color: string
    tab_background_color: string
    unselectedtab_text_color: string
    unselectedtab_background_color: string
    gradient_init_color: string
    gradient_middle_color: string
    gradient_end_color: string
    items: NbPersonatabItem[]
  }

  export interface NbPersonatabResponse {
    success: boolean
    row: NbPersonatab
  }

  export interface NbPersonatabsResponse {
    success: boolean
    rows: NbPersonatab[]
  }


  export interface NbPersonatabSuccessResponse {
    row?: number
    success: boolean
  }



  export interface NbMusicrowAvailableResponse {
    success: boolean
    rows?: NbPersonatabItem[]
  }

@Injectable()
export class PersonatabService {

    private API_ENDPOINT = `${environment.HOST}/adminapi/personatab/`

    constructor(private http: HttpClient) {}

    public getPersonatabs(): Observable<NbPersonatabsResponse> {
        return this.http
        .get(`${this.API_ENDPOINT}getpersonatabs`)
        .map(res => res as NbPersonatabsResponse)
    }

    public getPersonatabByID(id: number): Observable<NbPersonatabResponse> {
        return this.http
          .get(`${this.API_ENDPOINT}getpersonatab/id/${id}`)
          .map(res => res as NbPersonatabResponse)
      }

      public savePersonatab(row: NbPersonatab): Observable<NbPersonatabSuccessResponse> {
        return this.http
          .post(`${this.API_ENDPOINT}savepersonatab`, row)
          .map(res => res as NbPersonatabSuccessResponse)
      }

      public saveOrder(rows: NbPersonatab[]): Observable<any> {
        return this.http
          .post(`${this.API_ENDPOINT}savepersonataborder`, rows)
          .map(res => res as any)
      }

      public activatePersonatab(id: number): Observable<NbPersonatabSuccessResponse> {
        return this.http
          .get(`${this.API_ENDPOINT}activatepersonatab/id/${id}`)
          .map(res => res as NbPersonatabSuccessResponse)
      }

      public deactivatePersonatab(id: number): Observable<NbPersonatabSuccessResponse> {
        return this.http
          .get(`${this.API_ENDPOINT}activatepersonatab/id/${id}`)
          .map(res => res as NbPersonatabSuccessResponse)
      }

      public getSelectMusicRow(version: string, is_professional: boolean): Observable<NbMusicrowAvailableResponse> {
        const is_pro = is_professional ? 1 : 0
        return this.http
          .get(`${this.API_ENDPOINT}getmusicrowavailable/version/${version}/is_pro/${is_pro}`)
          .map(res => res as NbMusicrowAvailableResponse)
      }
}




// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/data/personatab.service.ts